// src/components/sections/StatsSection.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { MdOutlineFileDownloadDone } from "react-icons/md";
import { TbAward } from "react-icons/tb";
import { FaUsers } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";

const StatsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className="max-w-7xl mx-auto px-4 py-20" ref={ref}>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {/* Card 1 */}
        <div
          className="border border-white/20 p-6 rounded-lg"
          data-aos="fade-up"
          data-aos-delay="0"
        >
          <div className="flex justify-center items-center mb-4 text-white">
            <MdOutlineFileDownloadDone className="text-3xl sm:text-4xl md:text-[50px]" />
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white">
            {inView && <CountUp end={50} duration={5} />}+
          </h2>
          <p className="text-white text-xs sm:text-sm mt-2">Projects completed</p>
        </div>

        {/* Card 2 */}
        <div
          className="border border-white/20 p-6 rounded-lg"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="flex justify-center items-center mb-4 text-white">
            <TbAward className="text-3xl sm:text-4xl md:text-[50px]" />
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white">
            {inView && <CountUp end={5} duration={5} />}
          </h2>
          <p className="text-white text-xs sm:text-sm mt-2">Honorable award</p>
        </div>

        {/* Card 3 */}
        <div
          className="border border-white/20 p-6 rounded-lg"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="flex justify-center items-center mb-4 text-white">
            <FaUsers className="text-3xl sm:text-4xl md:text-[50px]" />
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white">
            {inView && <CountUp end={75} duration={5} />}+
          </h2>
          <p className="text-white text-xs sm:text-sm mt-2">Satisfied customers</p>
        </div>

        {/* Card 4 */}
        <div
          className="border border-white/20 p-6 rounded-lg"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div className="flex justify-center items-center mb-4 text-white">
            <MdManageAccounts className="text-3xl sm:text-4xl md:text-[50px]" />
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white">
            {inView && <CountUp end={18} duration={5} />}
          </h2>
          <p className="text-white text-xs sm:text-sm mt-2">Team Count</p>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;